//api: https://api.imgflip.com/get_memes

import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'





const App = ()=>{
  const [meme, setMeme] = React.useState({
    topText:' ',
    bottomText:'',
    img:"http://i.imgflip.com/1bij.jpg" 
  })
const [data, setData] = React.useState([])

useEffect(
  ()=>{
 async function getData(){
  const response = await fetch('https://api.imgflip.com/get_memes')
  const data = await response.json();
  setData(data.data.memes);

 } getData();
})


const getMemes = ()=>{
const randomNumber = Math.floor(Math.random()*data.length)
const url = data[randomNumber].url
setMeme((prev)=>{
  return{
    ...prev, img: url
  }
})
}
const handleClick = (e)=>{
  const {name, value} = e.target
 setMeme((prev)=>{
 return{...prev, [name]:value}
 })
  
}
// downlaod
const download = () => {
  var element = document.createElement("a");
  var file = new Blob(
    [
      meme.img
    ],
    { type: "image/*" }
  );
  element.href = URL.createObjectURL(file);
  element.download = "image.jpg";
  element.click();
};

return(
  <div className='memes-cotainer'>
 <div className='memes'>
  <div className='inputs-container'>
  <div className='top-inputs'>

  <label>Write the top text here</label>
 <input onChange={handleClick} name='topText'  value={meme.topText} className='top-text'></input>

  </div>
  
  <div className='bottom-inputs'> 
  <label>Write the bottom text here</label>
<input  onChange={handleClick} name='bottomText'  value={meme.bottomText}  className='bottom-text'></input>
  
</div>
  </div>


  <div className='memes-img-container'>
  <h1 className='h1-top-text'>{meme.topText}</h1>

 <img className='meme-img' src={meme.img}></img>
 

<h1 className='h1-bottom-text'>{meme.bottomText}</h1>


</div>
<div className='btn-container'>
  <button className='btn-click' onClick={getMemes}>Click to get an image</button>
  </div>
 </div>
{/* //download */}
 <div className="download-container">
  <a
    href={meme.img}
    download
    onClick={() => download()}
  >
    <i className="fa fa-download" />
    download
  </a>
</div>
{/* //download */}
  </div>

)

}







export default App;
